import React, {useEffect} from "react";
import "./style.css";
import Lottie from "react-lottie";
import animationData from '../../../../../static/json/questionnaire/weight-loss/LastingResults.json'

export const PcLastingResults = ({ clickNext = () => {}, clickPrev = () => {}, clicked, isCurPage, }) => {
    useEffect(() => {
        if (clicked) {
            clickNext("")
        }
    }, [clicked]);
  return (
    <div className="lasting-results-pc" data-model-id="16865:6724">
      <div className="contents">
        <div className="container">
          <div className="image-container">
              <Lottie
                  options={{
                      loop: false,
                      autoplay: false,
                      animationData: animationData,
                      rendererSettings: {
                          preserveAspectRatio: 'xMidYMid slice'
                      }
                  }}
                  height={400}
                  width={"100%"}
                  isPaused={!isCurPage} />
          </div>

          <div className="text-container">
            <p className="text-wrapper">Calo focuses on lasting results</p>

            <p className="subtitle">
              Calo&#39;s science-based approach helps you achieve lasting weight
              loss that fits your lifestyle.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
